import { ConfirmDialog } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { useBlocker } from '@tanstack/react-router';
import { useCallback, useRef } from 'react';
import { DashboardPage, type DashboardPageProps } from '../pages/DashboardPage.tsx';

export const GuardedDashboard = (props: Omit<DashboardPageProps, 'onDirtyChange'>) => {
  const { t } = useTranslation();
  const dirty = useRef(false);
  const blocker = useBlocker({
    shouldBlockFn: ({ current, next }) => dirty.current && current.pathname !== next.pathname,
    enableBeforeUnload: () => dirty.current,
    withResolver: true,
  });
  const track = useCallback((isDirty: boolean) => {
    dirty.current = isDirty;
  }, []);
  return (
    <>
      {blocker.status === 'blocked' ? (
        <ConfirmDialog
          title={t('dashboard.views.leaveTitle')}
          message={t('dashboard.views.leaveMessage')}
          confirmLabel={t('dashboard.views.leave')}
          cancelLabel={t('dashboard.views.stay')}
          closeLabel={t('common.close')}
          onConfirm={blocker.proceed}
          onCancel={blocker.reset}
        />
      ) : null}
      <DashboardPage {...props} onDirtyChange={track} />
    </>
  );
};
